import { render, staticRenderFns } from "./ContainerRequestsOrg.vue?vue&type=template&id=ba1599bc"
import script from "./ContainerRequestsOrg.vue?vue&type=script&lang=js"
export * from "./ContainerRequestsOrg.vue?vue&type=script&lang=js"
import style0 from "./ContainerRequestsOrg.vue?vue&type=style&index=0&id=ba1599bc&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports